import React, { FC } from 'react';
import { Image } from '@mantine/core';
import placeholder from '@assets/images/alert-report-placeholder.png';

const DashboardPlaceholder: FC = () => {
  return <Image src={placeholder} alt="placeholder" />;
};

export default DashboardPlaceholder;
